import request from "../utils/request";
// 登录
export const login = (data) => {
  return request({
    method: "post",
    url: "/user/public/login",
    data,
  });
};
// 登出
export const logout = () => {
  return request({
    method: "get",
    url: "/user/logout",
  });
};
// 获取当前登录用户
export const getUserInfo = () => {
  return request({
    method: "get",
    url: "/user/query",
  });
};
// 注册
export const register = (data) => {
  return request({
    method: "post",
    url: "/user/public/register",
    data,
  });
};
// 发送验证码
export const getCode = (params) => {
  return request({
    url: "/user/public/sendCode",
    method: "get",
    params,
  });
};
// 获取热门ip
export const getHotIps = () => {
  return request({
    url: "/ip/public/hot/list",
    method: "get",
  });
};
// // 获取单个ip
// export const getIpOne = (params:{id:number}) => {
//   return request({
//     url: '/ip/query/one',
//     method: 'get',
//     params
//   })
// }
// 获取ip集合
export const getIpList = () => {
  return request({
    url: "/ip/public/list",
    method: "get",
  });
};
//获取当前用户的好友

export const getFriends = () => {
  return request({
    url: "/friend/list",
    method: "get",
  });
};

//获取公告
export const getNoticeList = () => {
  return request({
    url: "/info/public/notice/list",
    method: "get",
  });
};
//获取公告
export const getPictureList = () => {
  return request({
    url: "/info/public/picture/list",
    method: "get",
  });
};
//上传接口
export const upload = (data) => {
  return request({
    url: "/oss/upload",
    method: "post",
    data,
  });
};
//修改用户形像
export const updateUserImg = (data) => {
  return request({
    url: "/user/update/appearance",
    method: "post",
    params: { ...data },
  });
};
//修改用户头像，头像框
export const updateUserAvatar = (data) => {
  return request({
    url: "/user/update/icon",
    method: "post",
    params: { ...data },
  });
};
//校验验证码
export const checkCode = (data) => {
  return request({
    url: "/user/public/checkCode",
    method: "post",
    data: { ...data },
  });
};
//确认账号
export const checkUserName = (data) => {
  return request({
    url: "/user/public/accountVerify",
    method: "post",
    data: { ...data },
  });
};
//忘记密码(未登录)
export const forgetPassword = (data) => {
  return request({
    url: "/user/public/updatePasswordByPhone",
    method: "post",
    data: { ...data },
  });
};
//修改密码(已登录)
export const upadtePassword = (data) => {
  return request({
    url: "/user/updatePassword",
    method: "post",
    data: { ...data },
  });
};
//修改昵称
export const updateUsername = (data) => {
  return request({
    url: "/user/update/username",
    method: "get",
    params: { ...data },
  });
};
//修改昵称
export const updatePhone = (data) => {
  return request({
    url: "/user/updatePhone",
    method: "post",
    data: { ...data },
  });
};
